@if (afDisclosureInfo ) {
  <div id="main-content" class="wrapper has-padding margin-height zoom-margin"
    (focusout)="onFocusOutMainContent($event)">
    <form [formGroup]="ackData">
      <div>
        <div class="bottom-space padding-top-three">
          <div>
            <button #pdfButton type="button" class="bofa--button secondary outlined"
              title="Required to view Acknowledgment of Consent" (click)="downloadAcknowledgmentPDF()"><abbr
            title="required">* </abbr>Download and view Acknowledgement of Consent</button>
            <mat-checkbox [checked]="termsCheck" [disabled]="true"></mat-checkbox>
          </div>
          @if (!termsCheck && hasBeenSubmitted) {
            <div class="padding-top">
              <mat-error>Please download and view Acknowledgement of Consent to continue</mat-error>
            </div>
          }
        </div>
        <div class="padding-top">
          @if (jobCountry !== 'CHN') {
            <div>
              <mat-checkbox aria-required="true" class="minor-check-padding" required (focusout)="termsOnBlur()"
                (focusin)="termsOnFocus()" formControlName="discTermsCheck">
                <mat-label class="whitespace-normal"><abbr title="required">* </abbr>I acknowledge that I have read and
                understood this Background Screening
                and Re-Screening Data Protection Notice - Declaration of Consent and that additional communications may be
                provided to me in English,
                and I am capable of understanding such communications. I consent to the processing of my personal data for
                the purposes described in this notice.
              </mat-label>
              @if (discTermsCheck.hasError('invalid') && check) {
                <mat-error class="whitespace-normal"> Please check the
                box to agree to the above language </mat-error>
              }
            </mat-checkbox>
          </div>
        }
        @if (jobCountry === 'CHN') {
          <div class="checkbox-format">
            <mat-checkbox aria-required="true" class="minor-check-padding" required (focusout)="chnCookiesDiscOnBlur()"
              (focusin)="chnCookiesDiscOnFocus()" formControlName="chnCookiesDisc">
              <mat-label class="whitespace-normal"><abbr title="required">* </abbr>The Company will process Personal Data
              as set out in this Notice and as further specified in the Cookie Policy hyperlinked in the Section titled
              "Cookies". I consent to such use.
            </mat-label>
            @if (chnCookiesDisc.hasError('invalid') && checkCHNCookies) {
              <mat-error class="whitespace-normal"> Please
              check the box to agree to the above language </mat-error>
            }
          </mat-checkbox>
          <mat-checkbox aria-required="true" class="minor-check-padding chn-check-padding" required
            (focusout)="chnPDDiscOnBlur()" (focusin)="chnPDDiscOnFocus()" formControlName="chnPDDisc">
            <mat-label class="whitespace-normal"><abbr title="required">* </abbr>The Company will process and retain
            Sensitive Personal Data as set out in Section titled "Personal Data Collection and Purposes of Use" of
            this notice. I consent to such use.
          </mat-label>
          @if (chnPDDisc.hasError('invalid') && checkCHNPDDisc) {
            <mat-error class="whitespace-normal"> Please check
            the box to agree to the above language </mat-error>
          }
        </mat-checkbox>
        <mat-checkbox aria-required="true" class="minor-check-padding chn-check-padding" required
          (focusout)="chnThirdDiscOnBlur()" (focusin)="chnThirdDiscOnFocus()" formControlName="chnThirdDisc">
          <mat-label class="whitespace-normal"><abbr title="required">* </abbr>The Company will transfer Personal Data
          to third parties within China, as detailed in Sections titled "Disclosure" and "Jurisdiction-Specific
          Clauses" of this Notice. I consent to such transfers.
        </mat-label>
        @if (chnThirdDisc.hasError('invalid') && checkCHNThirdDisc) {
          <mat-error class="whitespace-normal"> Please
            check
          the box to agree to the above language </mat-error>
        }
      </mat-checkbox>
      <mat-checkbox aria-required="true" class="minor-check-padding chn-check-padding" required
        (focusout)="chnTransferDiscOnBlur()" (focusin)="chnTransferDiscOnFocus()" formControlName="chnTransferDisc">
        <mat-label class="whitespace-normal"><abbr title="required">* </abbr>The Company will transfer Personal Data
        to third parties outside China, as detailed in Sections titled "Disclosure" and Jurisdiction-Specific
        Clauses" of this Notice. I consent to such transfers.
      </mat-label>
      @if (chnTransferDisc.hasError('invalid') && checkCHNTransferDisc) {
        <mat-error class="whitespace-normal">
        Please check the box to agree to the above language </mat-error>
      }
    </mat-checkbox>
  </div>
}
<mat-form-field class="margin-left-space max-zoom radio-padding width-350-margins">
  <mat-label>Date Signed</mat-label>
  <input value="{{ termDate }}" matInput disabled>
</mat-form-field>
</div>
</div>
<p class="bofa--heading is-8">Please sign below to indicate your consent to the terms of this Notice.</p>
@if (afDisclosureInfo) {
  <div class="width-750-margins">
    <app-wet-signature [signatureImg]="signatureImg" (sigURL)="getUrl($event)" (sigCheck)="sigCheck($event)">
    </app-wet-signature>
    @if (output.hasError('invalid') || sigCheckValue) {
      <mat-error> Please enter electronic signature </mat-error>
    }
  </div>
}
<mat-checkbox aria-required="true" required (focusout)="legalOnBlur()" (focusin)="legalOnFocus()"
  formControlName="legalRequirementsMet" class="minor-check-padding">
  <mat-label class="whitespace-normal"><abbr title="required">* </abbr>Yes, I agree that I have fully reviewed and
  completed the information above
</mat-label>
@if (legalRequirementsMet.hasError('invalid') && checkTwo) {
  <mat-error class="whitespace-normal"> Please check
  the box to agree to the above language </mat-error>
}
</mat-checkbox>
<div>
  <mat-form-field class="max-zoom width-350-margins" hideRequiredMarker>
    <mat-label><abbr title="required">* </abbr>Please enter your full name</mat-label>
    <input matInput placeholder="Full name" formControlName="applicantSignedName" required maxlength="250">
    <mat-error>Please enter your full name</mat-error>
  </mat-form-field>
</div>
<div>
  <mat-form-field class="max-zoom width-350">
    <mat-label>Date Signed</mat-label>
    <input value="{{ date }}" matInput disabled>
  </mat-form-field>
</div>
</form>
</div>
} @else {
  Loading Acknowledgement Information...
}
